import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class PublicGuard implements CanActivate {
    constructor(private router: Router) {}

    /*=====================================
      Blocks navigation to /auth/* routes when a token is already stored, except /auth/success
      — that route is always reachable since it's landing a freshly-issued token, regardless of
      any stale one already stored.
      @param _route - unused, required by the CanActivate signature
      @param state - the router state being navigated to; state.url is checked for the exemption
      @return true to allow navigation, false to block it (and redirect to /)
    ======================================*/
    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (state.url.startsWith('/auth/success')) {
            return true;
        }

        const token = localStorage.getItem('auth_token');

        if (token) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
